import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

export class AddTechUnlockCommand extends CommandBase {
    id: string;
    unlockId: string;

    constructor(id: string, unlockId: string) {
        super();
        this.id = id;
        this.unlockId = unlockId;
    }

    execute(data: RemoteConstantsModel): boolean {
        const index = data.techTree.findIndex(u => u.id === this.id);
        if (index < 0) {
            return false;
        }

        if (data.techTree[index].unlocks === undefined) {
            data.techTree[index].unlocks = [];
        }

        data.techTree[index].unlocks.push(this.unlockId);
        return true;
    }
}